<template>
  <UiModal
    modal-styles="mobile-bottom tablet-bottom"
    @close="$emit('close')"
    @value="(e) => $emit('value', e)"
    @input="(e) => $emit('input', e)"
  >
    <perfect-scrollbar @close="$emit('close')">
      <div class="feedback-container">
        <h3 class="text-h3-bold-up">Задайте вопрос о товаре</h3>
        <div class="sub-header">
          <span v-if="isMobile || isTablet">Задайте свой вопрос. </span>Вам
          ответит команда Price. Мы пришлём уведомление на вашу электронную
          почту, когда поступит ответ.
        </div>
        <div ref="form">
          <form class="form" novalidate @submit.prevent="onSubmit">
            <div class="title-container">
              <p class="text-body-m-book">Вопрос</p>
            </div>
            <UiPTextarea
              ref="textarea"
              v-model:value="feedbackItem.text"
              max-length="2000"
              :auto-height="true"
              name="text"
              class="pros input"
              placeholder="Напишите свой вопрос"
              :error="v$.text.$errors[0] ? showErrorMessage : ''"
            >
              <template #right>
                <ui-char-counter :max="2000" :value="feedbackItem.text" />
              </template>
            </UiPTextarea>

            <div class="title-container">
              <p class="text-body-m-book">Ваши данные</p>
            </div>
            <div class="row input">
              <div class="author">
                <UiPInput
                  ref="author"
                  v-model:value="feedbackItem.author"
                  name="author"
                  placeholder="Имя"
                  :error="v$.author.$errors[0] ? showErrorMessage : ''"
                  @focus="v$.$reset()"
                />
              </div>

              <div class="email">
                <UiPInput
                  ref="email"
                  v-model:value="feedbackItem.email"
                  name="email"
                  placeholder="E-mail"
                  :error="v$.email.$errors[0] ? showErrorMessage : ''"
                  @focus="v$.$reset()"
                />
              </div>
            </div>
            <ui-ui-button
              class="submit-button"
              :resize="true"
              @click="onSubmit"
            >
              Отправить вопрос</ui-ui-button
            >
          </form>
        </div>
        <div class="disclaimer">
          Нажимая кнопку «Отправить вопрос», вы
          <a
            class="visual_disclaimer"
            target="_blank"
            href="https://static.price.ru/docs/PriceExpressAggreement2.pdf"
            >соглашаетесь</a
          >
          с
          <a
            class="visual_disclaimer"
            target="_blank"
            href="https://static.price.ru/docs/PriceExpressPersonalDataPolicy.pdf"
            >политикой обработки персональных данных</a
          >,
          <nuxt-link
            class="visual_disclaimer"
            target="_blank"
            to="/user-agreement/"
          >
            пользовательским соглашением</nuxt-link
          >
          и на получение информационных и рекламных сообщений
        </div>
      </div>
    </perfect-scrollbar>
  </UiModal>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { required, email } from '@vuelidate/validators';
import { API } from '~/api/api';
import { useMediaQueryStore } from '~/stores/mediaQuery';

export default defineComponent({
  name: 'QuestionModal',
  props: {
    modelId: {
      type: Number,
      default: 0,
    },
  },
  emits: ['value', 'input', 'close'],
  setup(props, ctx) {
    const mediaStore = useMediaQueryStore();
    const isMobile = computed(() => mediaStore.isMobile);
    const isTablet = computed(() => mediaStore.isTablet);
    const feedbackItem = ref({
      text: '',
      model_id: props.modelId,
      author: '',
      email: '',
    });
    const rulesFeedbackItem = {
      text: { required },
      model_id: props.modelId,
      author: { required },
      email: { required, email },
    };

    const showErrorMessage = 'Поле обязательно для заполнения';

    async function onSubmit() {
      const { $ymAnyEvent } = useNuxtApp();
      $ymAnyEvent('reachGoal', 'click_Send_question');
      await v$.value.$validate();
      if (v$.value.$error) return;
      await API.post(
        `/models/${props.modelId}/questions?region_id=1`,
        feedbackItem.value
      ).catch((e) => console.error('post questions error', e));
      ctx.emit('close', 'success');
    }

    const v$ = useVuelidate(rulesFeedbackItem, feedbackItem);

    return {
      feedbackItem,
      onSubmit,
      v$,
      showErrorMessage,
      isMobile,
      isTablet,
    };
  },
});
</script>
<style scoped lang="scss" src="./question-modal.scss" />
